import { useState } from "react";
import { X } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

const KEY = "ccc_cookie_consent_v1";

// Hide the cookie banner on these routes — they have their own modal flows
// (Stripe / PayPal) that conflict visually with a bottom-right banner.
const HIDDEN_ROUTES = ["/success", "/cancel", "/account/login", "/account/forgot-password", "/account/set-password", "/admin", "/einlass"];

export const CookieConsent = () => {
  const [show, setShow] = useState(() => {
    if (typeof window === "undefined") return false;
    return !localStorage.getItem(KEY);
  });
  const location = useLocation();

  const accept = (mode) => {
    localStorage.setItem(KEY, JSON.stringify({ mode, ts: Date.now() }));
    setShow(false);
  };

  if (!show) return null;
  if (HIDDEN_ROUTES.some((p) => location.pathname.startsWith(p))) return null;

  return (
    <div
      data-testid="cookie-consent"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 z-30 max-w-sm bg-[#141414] border border-white/15 rounded-2xl p-4 shadow-2xl backdrop-blur"
    >
      <div className="flex items-start justify-between gap-3 mb-2">
        <div>
          <div className="eyebrow gold-text mb-1 text-[10px]">Cookies</div>
          <h3 className="font-display font-bold text-white text-sm">Wir respektieren deine Privatsphäre</h3>
        </div>
        <button
          data-testid="cookie-close"
          onClick={() => accept("essential_only")}
          className="text-zinc-500 hover:text-white"
          aria-label="Schließen"
        >
          <X size={16} />
        </button>
      </div>
      <p className="text-xs text-zinc-400 leading-relaxed mb-3">
        Nur technisch notwendige Cookies (Sprache, Warenkorb, Anmeldestatus).{" "}
        <Link to="/datenschutz" className="text-[#FFCC51] hover:underline">Mehr erfahren</Link>.
      </p>
      <div className="flex gap-2">
        <button
          data-testid="cookie-essential"
          onClick={() => accept("essential_only")}
          className="ghost-button text-[11px] flex-1 justify-center py-2"
        >
          Nur essenzielle
        </button>
        <button
          data-testid="cookie-accept-all"
          onClick={() => accept("all")}
          className="gold-button text-[11px] flex-1 justify-center py-2"
        >
          Verstanden
        </button>
      </div>
    </div>
  );
};
